import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { withRouter } from "react-router-dom";
import { messages } from "../../../../localization/messages";
import DocumentService from "../../../../services/DocumentService";
import { selectFilter } from "../../../../services/FilteringUtils";
import KnowledgeService from "../../../../services/KnowledgeService";
import PathUtil from "../../../../utils/PathUtil";
import { paths } from "../../../paths";
import FilteringComponent from "../../page/FilteringComponent";
import KnowledgeManagementSearch from "./KnowledgeManagementSearch";

class KnowledgeManagementSearchContainer extends FilteringComponent {
  constructor(props) {
    super(props);
    this.knowledgeService = new KnowledgeService(this.keycloak);
    this.documentService = new DocumentService(this.keycloak);
  }

  componentDidUpdate(prevProps) {
    super.componentDidUpdate();

    if (
      prevProps.shouldSearch !== this.props.shouldSearch &&
      this.props.shouldSearch &&
      this.props.searchValue
    ) {
      this.startLoading(this.initialPageInfo(), this.sortInfo);
    }
  }

  startLoading = (pageInfo, sortInfo) => {
    if (this.props.shouldSearch) {
      this.loadData(pageInfo);
    }
  };

  loadData = pageInfo => {
    this.adjustPageInfo(pageInfo);
    this.prepareCall(
      this.knowledgeService.search(
        pageInfo,
        undefined,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  adjustPageInfo = pageInfo => {
    if (this.props.searchValue) {
      pageInfo.filters = {
        ...pageInfo.filters,
        query: selectFilter(this.props.searchValue)
      };
    }
  };

  onDataLoad = data => {
    let pageInfo = data.page;
    pageInfo.filters = this.state.pageInfo.filters;
    this.setState({ content: [] });

    this.setState({
      content: data._embedded?.content || [],
      pageInfo: pageInfo,
      links: data._links
    });
  };

  onPageNumberClick = event => {
    const { pageInfo } = this.state;
    pageInfo.number = parseInt(event.target.id);
    this.loadData(pageInfo);
  };

  initialPageSize() {
    return 5;
  }

  onOpen = (id, name) => {
    const itemPath = PathUtil.itemPath(paths.KNOWLEDGE_ITEM, id);
    this.changePath(itemPath, name);
  };

  openInNewTab = id => {
    const itemPath = PathUtil.itemPath(paths.KNOWLEDGE_ITEM, id);
    window.open(itemPath, "_blank", "noopener");
  };

  onDownloadClick = url => {
    const confirm = window.confirm(messages.download_confirm_message);
    if (confirm) {
      this.prepareCall(
        this.documentService.downloadDocument(
          url,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  };

  render() {
    return (
      <KnowledgeManagementSearch
        {...this.renderProps()}
        onOpen={this.onOpen}
        openInNewTab={this.openInNewTab}
        onPageNumberClick={this.onPageNumberClick}
        onDownloadClick={this.onDownloadClick}
      />
    );
  }
}

export default withKeycloak(withRouter(KnowledgeManagementSearchContainer));
